import http from "./httpService";
const apiEndpoint = "/knowledgeBase";

/**---------------------- Portal Specific-------------- **/

export function getPortalCorpus(projectId) {
  return http.get(apiEndpoint + "/portalcorpusstatus/" + projectId);
}

export function getSpecificKB(projectId) {
  return http.get(apiEndpoint + "/portalproject/" + projectId );
}

export function portaldocsUpload(projectId, formData) {
  return http.post(apiEndpoint + "/portalupload/" + projectId, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

export function deletefileforPortal(projectId, etag) {
  return http.delete(apiEndpoint + "/portaldeleteFile/" + projectId + "/" + etag);
}

export function createProject(obj) {

  return http.post(apiEndpoint + "/whitelabelKB", obj);
}

export function deleteParagraph(projectId, key) {
  return http.delete(apiEndpoint + "/portalDeleteParagraph" +  "/" + projectId + "/" + key);
}

export function trainURLsForPortal(projectId, obj) {
  return http.post(`${apiEndpoint}/whitelabelUrlist/${projectId}`, obj);
}

export function addWhitelabelGSheet(projectID, data) {

  
  const params = new URLSearchParams({
    url: data.url,
    templateKey: data.template
  })


  return http.post(`${apiEndpoint}/whitelabelAddGSheet/${projectID}?${params}`);
}

export function syncWhitelabelGSheet(projectId, data) {

  
  const params = new URLSearchParams({
    url: data.url,
    templateKey: data.template
  })


  return http.post(`${apiEndpoint}/whitelabelSyncGSheet/${projectId}?${params}`);
}

export function getWhitelabelDocumentDownloadLink(projectId, etag) {
  return http.post(`${apiEndpoint}/whitelabelGetDocumentDownloadLink/${projectId}/${etag}`);
}

export function whitelabelDeleteKB(projectId, etag) {
  return http.delete(apiEndpoint +  "/whitelabelDelete/" + projectId + "/" + etag);
}




/**----------------------------------------------------- **/


export function getDocumentDownloadLink(projectId, etag) {
  return http.post(apiEndpoint + "/getDocumentDownloadLink/" + projectId +"/" + etag);
}


export function retrain(projectId, text) {
  return http.put(apiEndpoint + "/retrain", {
    projectId,
    text, 
  });
}


export function updateKB(change) {
  return http.patch(apiEndpoint + "/whiteLabelUpdate ", change)
}

export function addGSheet(projectID, data) {

  
  const params = new URLSearchParams({
    url: data.url,
    templateKey: data.template
  })


  return http.post(`${apiEndpoint}/addGSheet/${projectID}?${params}`);
}





export function fetchURLs(obj) {
  return http.post(apiEndpoint + "/fetchurls", obj);
}

export function trainURLs(projectID, obj) {
  return http.post(apiEndpoint + "/urlist/" + projectID, obj);
}

// export function deleteKB(projectId, etag) {
//   return http.delete(apiEndpoint +  "/" + projectId + "/" + etag);
// }



export function docsUpload(projectId, formData) {
  return http.post(apiEndpoint + "/upload/" + projectId, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}





export function deletefile(projectId, etag) {
  return http.delete(apiEndpoint + "/deleteFile/" + projectId + "/" + etag);
}


export function retryExtraction(projectId, etag) {
  return http.post(apiEndpoint + "/retryextraction/" + projectId +"/" + etag);
}

export function syncGSheet(projectId, data) {

  
  const params = new URLSearchParams({
    url: data.url,
    templateKey: data.template
  })


  return http.post(`${apiEndpoint}/syncGSheet/${projectId}?${params}`);
}
